import { ReactComponent as CaretDownIcon } from "@common/assets/images/shared-icons/caret-down-icon.svg";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import styled, { css } from "styled-components";

import { NotificationIndicator } from "./AppListDropdown.styles";

export const SelectedAppWithOptions = styled.div`
  max-width: 36rem;
  display: flex !important;
  justify-content: space-between;
  z-index: 45;
  padding-right: 0.4rem;
`;

export const SelectedAppContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const SelectedApp = styled.div`
  padding-left: 1rem;
  max-width: 28rem;
  display: flex;
  align-items: center;

  p {
    color: ${vars.colors.white};
    cursor: pointer;
  }
`;

export const AppNameParagraph = styled(Paragraph)<{ $wide?: boolean }>`
  max-width: 20rem;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  margin-right: 1rem;
`;

export const IconButton = styled.div<{
  $active: boolean;
  $addApp?: boolean;
}>`
  color: ${vars.colors.grey50};
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.$active &&
    css`
      color: ${vars.colors.grey30};
    `}
  ${(props) =>
    props.$addApp &&
    css`
      margin-left: 1rem;
    `}
`;

export const Down = styled(CaretDownIcon)`
  margin-left: 1rem;
`;

export const OptionsNotificationIndicator = styled(NotificationIndicator)`
  position: relative;
  right: auto;
`;

export const SmallDot = styled.div`
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;

  background-color: ${vars.colors.white};
`;
